import React, { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLang } from '../context/LangContext';
import Hero from '../components/sections/Hero';

const Services    = lazy(() => import('../components/sections/Services'));
const About       = lazy(() => import('../components/sections/About'));
const Advantages  = lazy(() => import('../components/sections/Advantages'));
const Partners    = lazy(() => import('../components/sections/Partners'));
const Contact     = lazy(() => import('../components/sections/Contact'));
const Locations   = lazy(() => import('../components/sections/Locations'));

export default function Home() {
  const { t } = useLang();
  return (
    <>
      <Helmet>
        <title>{t.meta.homeTitle}</title>
        <meta name="description" content={t.meta.homeDescription} />
        <meta property="og:title"       content={t.meta.homeTitle} />
        <meta property="og:description" content={t.meta.homeDescription} />
        <meta property="og:type"        content="website" />
      </Helmet>

      <main>
        <Hero />
        <Suspense fallback={<div className="h-28 bg-silver-light" />}>
          <Services />
        </Suspense>
        <Suspense fallback={<div className="h-28 bg-white" />}>
          <About />
        </Suspense>
        <Suspense fallback={<div className="h-28 bg-silver-light" />}>
          <Advantages />
        </Suspense>
        <Suspense fallback={<div className="h-28 bg-white" />}>
          <Partners />
        </Suspense>
        <Suspense fallback={<div className="h-28 bg-navy" />}>
          <Contact />
        </Suspense>
        <Suspense fallback={<div className="h-28 bg-white" />}>
          <Locations />
        </Suspense>
      </main>
    </>
  );
}
